wp.i18n.setLocaleData( { '': {} }, 'schedule-content-block' );